import { render, staticRenderFns } from "./ItemImageTranslate.vue?vue&type=template&id=62568a94&"
import script from "./ItemImageTranslate.vue?vue&type=script&lang=js&"
export * from "./ItemImageTranslate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports